<div class="outer-panel">
  <div class="cta inner-panel px-4 py-6">
    <div class="flex">
      <div class="xs-8">
        <div class="form-group form-group--checkbox">
          <div [formGroup]="formGroup">
            <dgx-dfb-checkbox
              [formControlName]="field.controlName"
              [field]="field"
            ></dgx-dfb-checkbox>
          </div>
        </div>
        <div class="mt-6">
          <p class="link">What does this cover?</p>
        </div>
      </div>
      <div *ngIf="amount! >= 1" class="xs-4 ml-2">
        <header>
          <h3>£ {{ amount | number: '1.2-2' }}</h3>
        </header>
        <p class="typog-caption">per month continuous cover</p>
      </div>
    </div>
    <div class="px-4" *ngIf="isExpanded">
      <p class="mb-4 mt-6">
        Under this policy, we’ll replace your mobile if it is stolen or if you
        lose it, and you’ll be able to make a claim quickly and easily. You’ll
        need to provide a crime reference number or police report wherever
        possible.
      </p>
      <div class="desc-header">
        You must take care of your mobile as you will not be able to claim for:
      </div>
      <ul class="px-6 py-4">
        <li>
          Negligent loss or theft: knowingly leaving your mobile where it could
          be lost, stolen or damaged (e.g. in a changing room locker that is
          left unlocked).
        </li>
        <li>
          Third-party loss or theft: your mobile is lost or stolen while in the
          possession of a third party who is providing a service to you (e.g.
          you leave your mobile with a customisation service and it is lost or
          stolen).
        </li>
        <li>
          Loss or theft resulting from the sale of your mobile (e.g. you sell
          your mobile but the buyer fails to pay).
        </li>
      </ul>
      <div></div>
    </div>
  </div>
</div>
